export enum UpcomingViewOptions {
  Calendar = 'calendar',
  List = 'list',
}

export enum CalendarViewOptions {
  Week = 'week',
  Month = 'month',
  FourDay = 'fourDay',
}
